// extracted by mini-css-extract-plugin
export default {"highlighted":"styledText_highlighted__JyHYR"};